// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2io7f","hidden":"style_hidden__3YPQp"};